<template>
    <div class="box" @mousemove="moveFunc">
        <el-container style="height:100vh;">
            <el-aside class="over-visible aside no_print">
                <div class="full_height_scrollbar">
                  <img src="./assets/logo2.png" class="asideLogo" @click="showCompanyUrl"/>
                  <div v-for="(menu, index) in menu_list" :key="'menu_'+index" >
                    <!-- <span style="color:red;">{{menu.module+"//"}}</span>  -->
                    <div class="menu" :class="{show : current == index, active : current_menu.indexOf(menu.con) == 0 }" @mouseenter="current = index" @mouseleave="current = -1" v-if="module.indexOf(','+menu.module+',') >= 0">
                      <div class="item">
                        <div class="itemBox clearfix">
                          <i :class="menu.icon"></i>
                          <div>{{menu.label}}</div>
                        </div>
                        <div :class="[menu.num>99?'overNum':'lessNum','alertNumber']">
                          <el-badge type="danger" :value="menu.num" :hidden="!menu.num" :max="99" ></el-badge>
                        </div>
                      </div>
                      <div class="children_menu" :ref="'menu_'+index" :style="{'margin-top' : marginCenter('menu_'+index) }">
                        <div class="menu_col_other" v-for="(child, indx) in menu.children" :key="'child_'+indx">
                          <!-- <i class="el-icon-caret-left meun_arrow"></i> -->
                          <div  class="menu_col" v-if="showCol(child)">
                            <!-- <div class="col_name">{{ child.label }}</div> -->
                            <div class="menu_col_link_div" v-for="(item, ind) in child.children" :key="'item_'+ind">
                              <div class="link" v-if="module.indexOf(','+item.module+',') >= 0" @click.stop="showTab(item)">
                                <el-link class='sub_link' :underline="false" >{{ item.label }}</el-link>
                                <div :class="[item.num>99?'overNum':'lessNum','linkAlertNum']">
                                  <el-badge type="danger" :value="item.num" :hidden="!item.num" :max="99" >
                                  </el-badge>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
            </el-aside>
        <el-container>
        <el-header class="elHeader no_print">
        <div class="companyName">{{companyName}}</div>
        <img @click="switchOpen" v-if="unionCompany.length>0" style="width: 17px;margin-left: 10px;float: left;margin-top: 14px;" src="/icon/switch.png">
        <span class="mobileCodeName mall" @click="()=>{this.OpenMall()}">应用商城</span>
        <img src="/icon/mall.png" @click="()=>{this.OpenMall()}" class="mobileCodeName mobileCodeImg" style="margin: 0 5px;">
        <el-dropdown @command="handleCommand">
            <div class="topAvatarDiv" >
                <span style="padding-right: 5px;font-size: 14px;padding-left: 15px;border-left: 1px solid;">帮助</span>
                <img src="/icon/question.png" class="mobileCodeImg" >
            </div>
            <el-dropdown-menu slot="dropdown" style="padding-top: 1px;padding-bottom: 0">
                <el-dropdown-item @click.native="videoaDialoga()">PC端提货视频</el-dropdown-item>
                <el-dropdown-item @click.native="videobDialogb()">移动端提货视频</el-dropdown-item>
                <el-dropdown-item @click.native="videodDialogd()">期初导入教学视频</el-dropdown-item>
                <el-dropdown-item command="document">使用说明书</el-dropdown-item>
                <el-dropdown-item command="documentEasy">简化使用说明书</el-dropdown-item>
                <el-dropdown-item @click.native="videocDialogc()">谷歌下载视频</el-dropdown-item>
                <el-dropdown-item command="Chrome">下载谷歌浏览器</el-dropdown-item>
                <el-dropdown-item>联系:17712686596</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
        <Screenfull style="float:right" />
        <el-dropdown @command="handleCommand" class="dropdown">
          <!-- <span>{{name}}</span>
          <i class="el-icon-arrow-down dropdownIcon"></i> -->
          <div class="topAvatarDiv" style="padding-right: 0px !important;">
              <div class="separateLine" style="margin-bottom: 17px;"></div>
              <img class="topAvatar" src="./assets/avatar.png" alt="头像">
          </div>
          <el-dropdown-menu slot="dropdown" style="padding: 0 !important;">
            <div class="perBgTopDiv">
              <div class="perTopItem">
                  <img class="avatar" src="./assets/avatar.png" alt="头像">
              </div>
              <div class="perTopItem" style="margin: 5px 0;">
                  <span v-if="occupation">{{occupation}} - </span>
                  {{name}}
              </div>
              <div class="perTopItem" v-if="userMobile">
                  <img class="phone"  src="./assets/telephone.png"> {{userMobile}}
              </div>
            </div>
            <el-dropdown-item command="personal">
              <img class="fphone" src="./assets/personal.png">个人中心
            </el-dropdown-item>
            <el-dropdown-item command="refresh">
              <img class="fphone" src="./assets/refresh.png">刷新
            </el-dropdown-item>
            <el-dropdown-item command="loginOut">
                <div style="text-align: center">
                    <img src="./assets/signOut.png">
                    退出
                </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="mobileCodeBox">
          <div class="mobileCodeName clearfix" >
            <span style="border-left: 1px solid;padding-left: 10px;">手机端</span>
            <img src="/icon/upperRight_code.png" class="mobileCodeImg"/>
          </div>
          <div class="mobileCodeBoxC clearfix">
            <div class="triangle-up"></div>
            <div class="mobileCodeImgBox">
              <img src="/icon/minpro.jpg" class="mobileCode"/>
              <div class="mobileCodeImgName">小程序</div>
            </div>
            <div class="mobileCodeImgBox">
              <img src="/icon/gongzhonghao.jpg" class="mobileCode"/>
              <div class="mobileCodeImgName">公众号</div>
            </div>
          </div>
        </div>
        </el-header>
				<el-main class="main container">
					<el-tabs class="body_tab" v-model="current_tab" type="border-card" @tab-remove="removeTab" lazy :before-leave="changeTab">
						<el-tab-pane class="tab_content no_print" :closable="false" label="首页" name="首页" >
							<span slot="label"> <span class="top_left"></span> 首页 <span class="top_right"></span></span>
							<component ref="homepage" :is="'Home'" @clickNewAdd="addTab"></component>
						</el-tab-pane>
						<el-tab-pane class="tab_content" v-for="(item) in tabs"  :key="'tab_content_'+item.name" :label="item.label" :name="item.name">
							<span slot="label"> <span class="top_left"></span> {{item.label}} <i class="el-icon-error" @click.stop="closeTab(item.name)"></i>  <span class="top_right"></span></span>
							<keep-alive>
								<!-- @clickAdd-新增 @clickClose-关闭 @clickNewAdd created by xiong-->
								<component :ref="item.name" :is="item.content" @clickAdd="showTab" @clickNewAdd="addTab" @clickClose="removeCurTab"></component>
							</keep-alive>
						</el-tab-pane>
					</el-tabs>
					<div class="message_path_box" ref="message_path_box" @mousedown="movestart"  @mouseup="touchend" :style="'left:85px;top:'+messTop+'px;'">
						<div class="message_path" id="message_path" :class="{hide_sub : !show_sub}">
							<div class="message_round" @click="show_sub = !show_sub">
								消息
								<i v-if="totalMess>0">{{totalMess}}</i>
							</div>
							<div class="sub_path">
								<div v-for="(item,index) in messFloat" :key="index">
									<div class="sub_mess" v-if="module.indexOf(','+item.code+',')!=-1" @click="jumpPage(item.name,index)">
										<span>{{item.name}}</span>
										<i v-if="item.value>0">{{item.value}}</i>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="message_path_boxs" v-drag v-if="module.indexOf(',sales-price-plate-view,')!=-1" :style="'left:5px;'+messTop+'px;'">
						<div class="message_paths" id="message_path" :class="{hide_sub : !show_sub}">
							<div class="message_round" @click="openOffer">
								报价<br/>展板
							</div>
						</div>
					</div>
				</el-main>
            </el-container>
        </el-container>
		<!-- <audio src="/icon/audio.mp3" id="audio"></audio> -->
		

		<!--到期弹窗提醒-->
		<div class="modalBox" v-if="alertInfo.alert"></div>
		<div class="alertBox" v-if="alertInfo.alert">
			<div class="topBox">到期提醒</div>
			<div class="midBox">
				<div class="midItem">尊敬的用户您好~！</div>
				<div class="midItem">
					您使用的产品（ {{alertInfo.product}} ）
					到期时间为 <span class="lightColor">{{alertInfo.expiry_time|dateFormat}}</span> ,
					还有 <span class="lightColor">{{alertInfo.rest_days}}</span> 天即将到期。
				</div>
        <div class="midItem">若到期后仍未续费，阿里云将自动关闭服务器，为不影响您的正常使用，</div>
				<div class="midItem">请联系客服及时续费，或直接汇款至下面账号，谢谢~！</div>
				<div class="midSign">{{alertInfo.sign}}</div>
			</div>
			<div class="bottomBox">
				<div class="left">
					<div class="bottomItem accountTitle">{{alertInfo.account_title}}</div>
					<div class="bottomItem">{{alertInfo.look_up}}</div>
					<div class="bottomItem">代码：{{alertInfo.code}}</div>
					<div class="bottomItem">开户银行：{{alertInfo.bank}}</div>
					<div class="bottomItem">账户号码：{{alertInfo.account_number}}</div>
					<div class="bottomItem">地址：{{alertInfo.address}}</div>
					<div class="bottomItem">电话：{{alertInfo.tel}}</div>
				</div>
				<div class="right">
					<div class="payTypeItem">{{alertInfo.type}}</div>
					<div>
						<!--<img :src="alertInfo.pay_url" alt="付款码" class="payImg">-->
						<img src="./assets/pay_code.png" alt="付款码" class="payImg">
					</div>
				</div>
			</div>
			<div class="readBtnDiv">
				<el-button size="small" class="readBtn" @click="readAlert">我知道了</el-button>
			</div>
		</div>
		<el-dialog v-dialog-drag :visible.sync="offer" v-if="offer" class="eldialog specTable" width="1200px" :modal="false" custom-class="full_dialog">
			<div slot="title" class="offerTitle">
				<img class="company_title" :src="companyMess.picture" alt="">
				<span>{{companyMess.name}}-实时报价单</span>
			</div>
            <div class="printSetBox clearfix">
				<displayBoard />
			</div>
    </el-dialog>
    <el-dialog  v-dialog-drag  :visible.sync="companySwitch" class="eldialog specTable" width="300px" :modal="false" custom-class="full_dialog">
      <div slot="title" class="offerTitle">
        <span> 公司切换</span>
      </div>
      <div  class="printSetBox clearfix"  v-for="(item,index) in unionCompany" :key="index" :id="item.company_id" @click="switchChoose(item)" style="padding: 10px 10px;border-bottom: 1px solid #f4f4f4;">
        <!-- 图图 -->
        <span>{{item.company_name}}</span>
        <img src="/icon/isCheck.png" v-if="item.company_id==ischeck" style="width: 19px;float: right;">
      </div>
      <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn"  @click="settlementConfirm">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="移动端视频" :visible.sync="videobDialog" class="eldialog" width="350px" :modal="false" :before-close="videobCancel" v-dialogDrag>
        <video width="320" id="video2" src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/%E7%A1%AC%E6%9C%A8%E7%A7%BB%E5%8A%A8%E7%AB%AF%E6%95%99%E5%AD%A6%E8%A7%86%E9%A2%91.mp4" controls="controls">
        </video>
    </el-dialog>
    <el-dialog title="PC端视频" :visible.sync="videoaDialog" class="eldialog" width="1050px" :modal="false" :before-close="videoaCancel" v-dialogDrag>
        <video width="1012" id="video1" src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/%E7%A1%AC%E6%9C%A8pc%E6%95%99%E5%AD%A6.mp4" controls="controls">
        </video>
    </el-dialog>
    <el-dialog title="谷歌下载视频" :visible.sync="videocDialog" class="eldialog" width="1050px" :modal="false" :before-close="videocCancel" v-dialogDrag>
        <video width="1012" id="video3" src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/%E8%B0%B7%E6%AD%8C%E6%B5%8F%E8%A7%88%E5%99%A8%E5%AE%89%E8%A3%85%E8%AE%BE%E7%BD%AE.mp4" controls="controls">
        </video>
    </el-dialog>
    <el-dialog title="期初导入教学视频" :visible.sync="videodDialog" class="eldialog" width="1050px" :modal="false" :before-close="videodCancel" v-dialogDrag>
        <video width="1012" id="video4" src="https://cloud-wh-dev.oss-cn-shanghai.aliyuncs.com/video/%E6%9C%9F%E5%88%9D%E5%AF%BC%E5%85%A5%E6%95%99%E5%AD%A6%E8%A7%86%E9%A2%91.mp4 " controls="controls">
        </video>
    </el-dialog>
    <!-- 商城 -->
    <shoppMall :DialogVisible="mallDialogVisible" @dialogClose="dialogClose"></shoppMall>
  </div>
</template>
<script>
import Screenfull from './components/screenfull';
import shoppMall from './components/shoppingMall/mall';
const initMenuConf = [
  {
    name: "客户",
    label: "客户",
    module: "customer",
    icon: 'base_customer',
    con: "customer",
    bell_signs: ['office-leave'],
    children: [
      {
        name: "客户",
        label: "客户",
        module: "customer2",
        children: [
          {
            name: "客户管理",
            label: "客户管理",
            module: "customer-manage",
            content: "customerList"
          },
          {
            name: "供应商管理",
            label: "供应商管理",
            module: "supplier-manage",
            content: "customerSupplier"
          },
          {
            name: "开证公司管理",
            label: "开证公司管理",
            module: "issuing-manage",
            content: "customerIssueManagement"
          }
        ]
      },
      {
        name: "销售工作台",
        label: "销售工作台",
        module: "supplier",
        children: [
          {
            name: "销售工作台",
            label: "销售工作台",
            module: "customer-index",
            content: "customerSalesBench"
          },
          {
            name: "效率汇总表",
            label: "效率汇总表",
            module: "customer-analysis",
            content: "turnoverRadio"
          },
          {
            name: "OA系统",
            label: "OA系统",
            module: "office-leave",
            content: "customerOASystem",
            bell_signs: ['office-leave'],
          },
        ]
      },
    ]
  },
  {
    name: "销售",
    label: "销售",
    module: "sell",
    icon: 'base_sale',
    con: "sale",
    bell_signs: ['sell-review-view','sell-return-review'],
    children: [
      {
        name: "销售单据",
        label: "销售单据",
        module: "sell-doc",
        children: [
          {
            name: "销售单",
            label: "销售单",
            module: "sell-item",
            content: "saleOrder",
          },
          {
            name: "销售审核",
            label: "销售审核",
            bell_signs: ['sell-review-view'],
            module: "sell-review",
            content: "saleReview",
          },
          {
            name: "调货单",
            label: "调货单",
            module: "sell-dispatch",
            content: "saleTransfer",
          },
          {
            name: "退货管理",
            label: "退货管理",
            module: "sell-return",
            bell_signs: ['sell-return-review'],
            content: "saleRefund",
          },
          {
            name: "预售单",
            label: "预售单",
            module: "pre-sell",
            content: "preSaleOrder",
          },
        ]
      },
      {
        name: "销售报表",
        label: "销售报表",
        module: "sell-report",
        children: [
          {
            name: "现货库存",
            label: "现货库存",
            module: "sell-report-stock",
            content: "saleStock",
          },
          {
            name: "销售统计",
            label: "销售统计",
            module: "sell-report-statistic",
            content: "saleStatistics",
          },
          {
            name: "销售汇总",
            label: "销售汇总",
            module: "sell-report-total",
            content: "saleReportSummary",
          },
          // {
          //   name: "撤单记录",
          //   label: "撤单记录",
          //   module: "sell-report-total",
          //   content: "cancellationRecord",
          // },
          // {
          // 	name: "销售出库明细表",
          // 	label: "销售出库明细表",
          // 	module: "sell-report-out",
          // 	content: "saleReportOutboundy",
          // },
          {
            name: "调货单记录",
            label: "调货单记录",
            module: "sell-report-dispatch",
            content: "saleTransferList",
          }
        ]
      }
    ]
  },
  {
    name: "采购",
    label: "采购",
    module: "purchase",
    icon: 'base_purchase',
    bell_signs: ['purchase-report-road-instore'],
    con: "purchase",
    children: [
      {
        name: "采购单据",
        label: "采购单据",
        module: "purchase-doc",
        children: [
          {
            name: "采购订单",
            label: "采购订单",
            module: "purchase-order",
            content: "purchaseList",
          },
          {
            name: "直接导入",
            label: "直接导入",
            module: "purchase-in",
            content: "purchaseWarehouse",
          }
        ]
      },
      {
        name: "采购报表",
        label: "采购报表",
        module: "purchase-report",
        children: [
          {
            name: "在途资源",
            label: "在途资源",
            module: "purchase-report-road",
            bell_signs: ['purchase-report-road-instore'],
            content: "purchaseMidway",
          },
          {
            name: "合同分析表",
            label: "合同分析表",
            module: "purchase-report-analyze",
            content: "purchaseReportAnalysis"
          },
          {
            name: "采购入库明细",
            label: "采购入库明细",
            module: "purchase-report-in-trace",
            content: "purchaseReportWarehouse"
          }
        ]
      }
    ]
  },
  {
    name: "加工",
    label: "加工",
    module: "process",
    icon: 'base_machining',
    con: "machining",
    children: [
      {
        name: "加工单",
        label: "加工单",
        module: "process-doc",
        children: [
          {
            name: "加工单",
            label: "加工单",
            module: "process-doc-list",
            content: "machiningFakeIndex",
          },
          {
            name: "费用结算单",
            label: "费用结算单",
            module: "process-doc-fee",
            content: "machiningFakeMachSettlement",
          },
          {
            name: "成本核算单",
            label: "成本核算单",
            module: "process-doc-costing",
            content: "machiningFakeCostCheck",
          },
        ]
      },
      {
        name: "加工记录",
        label: "加工记录",
        module: "process-report",
        children: [
          {
            name: "原料领料记录",
            label: "原料领料记录",
            module: "process-report-materials",
            content: "machiningReportMaterials",
          },
          {
            name: "湿板导入记录",
            label: "湿板导入记录",
            module: "process-report-wet",
            content: "machiningReportWetIn",
          },
          {
            name: "干板导入记录",
            label: "干板导入记录",
            module: "process-report-dry",
            content: "machiningReportDryIn",
          }
        ]
      }
    ]
  },
  {
    name: "仓库",
    label: "仓库",
    module: "warehouse",
    icon: 'base_house',
    con: "warehouse",
    bell_signs: ['warehouse-doc-out-confirm','warehouse-doc-return'],
    children: [
      {
        name: "仓库单据",
        label: "仓库单据",
        module: "warehouse-doc",
        children: [
          {
            name: "出库确认",
            label: "出库确认",
            module: "warehouse-doc-out",
            bell_signs: ['warehouse-doc-out-confirm'],
            content: "warehouseComponentsReceivableReceivableOutbound",
          },
          {
            name: "库存管理",
            label: "库存管理",
            module: "warehouse-statistic",
            content: "warehouseStatistics",
          },
          {
            name: "组装拆卸",
            label: "组装拆卸",
            module: "warehouse-combind",
            content: "warehouseAssembly",
          },
          {
            name: "退货入库",
            label: "退货入库",
            module: "warehouse-doc-return",
            bell_signs: ['warehouse-doc-return'],
            content: "warehouseDocReturn",
          },
          {
            name: "库存结余",
            label: "库存结余",
            module: "warehouse-balance",
            content: "inventoryBalance",
          }
        ]
      },
      {
        name: "仓库报表",
        label: "仓库报表",
        module: "warehouse-report",
        children: [
          {
            name: "出库单记录",
            label: "出库单记录",
            module: "warehouse-report-out-order",
            content: "warehouseOutbound"
          },
          {
            name: "出库明细记录",
            label: "出库明细记录",
            module: "warehouse-report-out-inventory",
            content: "warehouseOutdetail"
          },
          {
            name: "库存汇总表",
            label: "库存汇总表",
            module: "warehouse-inventory-report",
            content: "warehouseReportStatistics"
          },
          {
            name: "退货记录",
            label: "退货记录",
            module: "warehouse-report-return-log",
            content: "warehouseReportRefound",
          },
          {
            name: "盘点记录",
            label: "盘点记录",
            module: "warehouse-report-take-stock",
            content: "warehouseInventory",
          },
        ]
      },

    ]
  },
  {
    name: "财务",
    label: "财务",
    module: "finance",
    icon: 'base_finance',
    con: "finance",
    bell_signs: ['finance-doc-receivable-out-review','finance-fee-review'],
    children: [
      {
        name: "财务单据",
        label: "财务单据",
        module: "finance-doc",
        children: [
          {
            name: "应收管理",
            label: "应收管理",
            module: "finance-doc-receivable",
            bell_signs: ['finance-doc-receivable-out-review'],
            content: "financeReceivable",
          },
          {
            name: "应付管理",
            label: "应付管理",
            module: "finance-doc-payable",
            content: "payReceivable",
          },
          {
            name: "费用审核",
            label: "费用审核",
            module: "finance-fee-review",
            bell_signs: ['finance-fee-review'],
            content: "financeReview",
          },
          {
            name: "费用管理",
            label: "费用管理",
            module: "finance-fee-manage",
            content: "financeStatistics",
          },
          {
            name: "账户管理",
            label: "账户管理",
            module: "finance-account-manage",
            content: "accountManage",
          },
        ]
      },
      {
        name: "财务报表",
        label: "财务报表",
        module: "finance-report",
        children: [
          {
            name: "客户对账单",
            label: "客户对账单",
            module: "finance-report-customer",
            content: "financeReportStatements",
          },
          {
            name: "销售利润表",
            label: "销售利润表",
            module: "finance-report-profit",
            content: "financeReportIncome",
          },
          {
            name: "成本查看",
            label: "成本查看",
            module: "finance-report-cost-view",
            content: "costView",
          },
          {
            name: "财务报表",
            label: "财务报表",
            module: "finance-report-month",
            content: "financemonth",
          },
        ]
      },
    ]
  },
  {
    name: "数据",
    label: "数据",
    module: "data",
    icon: 'base_data',
    con: "charts",
    children: [
      {
        name: "数据1",
        label: "数据1",
        module: "data1",
        children: [
          {
            name: "数据2",
            label: "数据2",
            module: "data2",
            content: "chartsIndex",
          },
          {
            name: "图形",
            label: "图形",
            module: "data-graph",
            content: "chartsChart",
          },
          {
            name: "表格",
            label: "表格",
            module: "data-table",
            content: "chartsTable",
          },
        ]
      },
    ]
  },
  {
    name: "店铺",
    label: "店铺",
    module: "shop",
    icon: 'base_shop',
    con: "shop",
    children: [
      {
        name: "企业风采1",
        label: "企业风采1",
        module: "shop-company",
        children: [
          {
            name: "企业风采2",
            label: "企业风采2",
            module: "shop-company2",
            content: "shopEnterpriseStyle",
          },
        ]
      },
      {
        name: "店铺1",
        label: "店铺1",
        module: "shop-shop",
        children: [
          {
            name: "店铺管理",
            label: "店铺管理",
            module: "shop-shop-manage",
            content: "shopIndex",
          },
        ]
      },
      {
        name: "谱木云链1",
        label: "谱木云链1",
        module: "shop-cloud",
        children: [
          {
            name: "谱木云链",
            label: "谱木云链",
            module: "shop-cloud-link",
            content: "shopLink",
          },
        ]
      },
    ]
  },
  {
    name: "云链",
    label: "云链",
    module: "cloud",
    icon: 'base_cloud',
    con: "cloud",
    children: [
      {
        name: "云链",
        label: "云链",
        module: "cloud-chain",
        children: [
          {
            name: "谱木云链",
            label: "谱木云链",
            module: "cloud-chain-product",
            content: "",
          }
        ]
      }
    ]
  },
  {
    name: "金融",
    label: "金融",
    module: "banking",
    icon: 'base_financeB',
    con: "cloud",
    bell_signs: ['redeem-order-manage'],
    children: [
      {
        name: "金融",
        label: "金融",
        module: "banking-base",
        children: [
          {
            name: "融资管理",
            label: "融资管理",
            module: "finance-order-manage",
            content: "bankFinancingManager",
          },
          {
            name: "赎货应付",
            label: "赎货应付",
            module: "redeem-order-manage",
            bell_signs: ['redeem-order-manage'],
            content: "bankpayableManager",
          },
          {
            name: "融资库存",
            label: "融资库存",
            module: "finance-inventorys",
            content: "bankFinanceManager",
          },
        ]
      },
      {
        name: "融资报表",
        label: "融资报表",
        module: "purchase-finance-report",
        children: [
          {
            name: "融资合同报表",
            label: "融资合同报表",
            module: "finance",
            content: "bankFinanceContract",
          },
          {
            name: "赎货详情",
            label: "赎货详情",
            module: "redeem-details",
            content: "foreclosureDetail",
          }
        ]
      },
    ]
  },
  {
    name: "设置",
    label: "设置",
    module: "setting",
    icon: 'base_set',
    con: "setting",
    children: [
      {
        name: "基础设置",
        label: "基础设置",
        module: "setting-base",
        children: [
          {
            name: "商品管理",
            label: "商品管理",
            module: "setting-base-goods",
            content: "settingProduction",
          },
          {
            name: "下拉设置",
            label: "下拉设置",
            module: "setting-base-down",
            content: "settingOption",
          },
          {
            name: "库存预警",
            label: "库存预警",
            module: "setting-base-inventory-alert",
            content: "warehouseReportAdvance"
          },
          {
            name: "销售定价",
            label: "销售定价",
            module: "setting-advanced-pricing",
            content: "settingSalesPricing"
          },
          // {
          // 	name: "客户设置",
          // 	label: "客户设置",
          // 	module: "customer-config",
          // 	// module: "setting-advanced-pricing",
          // 	content: "settingCustomer"
          // },
        ]
      },
      {
        name: "其它设置",
        label: "其它设置",
        module: "setting-advanced",
        children: [
          {
            name: "用户管理",
            label: "用户管理",
            module: "setting-advanced-user",
            content: "settingAccount",
          },
          {
            name: "高级设置",
            label: "高级设置",
            module: "setting-advanced-config-edit",
            content: "settingSenior",
          },
          {
            name: "操作日志",
            label: "操作日志",
            module: "setting-advanced-operator-log",
            content: "settingOperationLog",
          },
          // {
          // 	name: "锁货设置",
          // 	label: "锁货设置",
          // 	module: "setting-advanced-lock-set",
          // 	content: "settingLockSettings"
          // },
          // {
          // 	name: "清空数据",
          // 	label: "清空数据",
          // 	module: "system-data-clear",
          // 	content: "systemClear",
          // },
          // {
          // 	name: "打印设置",
          // 	label: "打印设置",
          // 	module: "setting-advanced-print",
          // 	content: "printSet",
          // },
          // {
          // 	name: "显示设置",
          // 	label: "显示设置",
          // 	module: "setting-advanced-show",
          // 	content: "showSet",
          // },
        ]
      },
      {
        name: "辅助资料",
        label: "辅助资料",
        module: "setting-assistance",
        children: [
          {
            name: "企业设置",
            label: "企业设置",
            module: "setting-base-company",
            content: "settingShop"
          },
          {
            name: "店铺设置",
            label: "店铺设置",
            module: "setting-base-shop",
            content: "settingShop",
          },
          {
            name: "云链管理",
            label: "云链管理",
            module: "setting-assistance-cloud-manager",
            content: "cloudManageBox",
          },
          {
            name: "云铺管理",
            label: "云铺管理",
            module: "cloud-store",
            content: "yunpuManage",
          },
          {
            name: "谱木云链",
            label: "谱木云链",
            module: "setting-assistance-cloud-product",
            content: "",
          },
          {
            name: "加工设置",
            label: "加工设置",
            module: "setting-base-factory",
            content: "settingShop",
          }]
      }
    ]
  },
];
	let ws = null;
	// let timeLimit=null;
export default {
  components: {
    Screenfull,
    shoppMall
  },
  data() {
    return {
      alertInfo: {},
      isCollapse: true,
      current: -1,
      current_tab: '首页',
      current_menu: "",
      tabs: [],
      show_sub: false,
      offer: false,
      companyMess: [],
      menu_list: this.$cloneJson(initMenuConf),
      module: localStorage.dw_erp_power_code,
      companyName: localStorage.dw_erp_company_name,
      unionCompany: JSON.parse(localStorage.dw_erp_union_company),
      name: localStorage.dw_erp_user_name,
      userMobile: localStorage.dw_erp_user_mobile,
      occupation: localStorage.dw_erp_user_occupation,
      messFloat: [],
      menu_sign_data: [],//菜单标记数据
      totalMess: 0,
      messTop: 500,
      isMove: false,
      touchX: 0,
      touchY: 0,
      startX: "",
      startY: "",
      companySwitch:false,
      ischeck:false,
      companyItem:{}, 
      videobDialog:false,
      videoaDialog:false,
      videocDialog:false,
      videodDialog:false,
      mallDialogVisible:false,
      userCompany_id:localStorage.dw_erp_user_company_id,//公司id
    }
  },
  mounted() {
    this.messTop = document.body.clientHeight - 40;
  },
  created() {
    document.title = "谱木云";
    this.socket();
    this.checkExpiry();
  },
  methods: {
    OpenMall(){
      this.mallDialogVisible = true;
    },
    dialogClose(params){
      this.mallDialogVisible = params;
    },
    switchOpen(){
      this.unionCompany.forEach(item=>{
        if(item.company_id == this.userCompany_id){
          this.ischeck=item.company_id
          this.companyItem=item
        }
      })
      this.companySwitch=true
    },
    switchChoose(e){
      this.ischeck=e.company_id
      this.companyItem=e
    },
    settlementConfirm(){
      if(this.companyItem.company_id==this.userCompany_id){
        this.companySwitch=false;
      }else{
        if (ws) {
          ws.close()
        }
        this.postFunc("erp/cross.login",{id:this.companyItem.id},response=>{
          // top.location.replace("https://"+this.companyItem.domain+".mix-test.dwood365.com/transfer"+"?token="+response.data.data.token+"&domain="+this.companyItem.domain);
          top.location.replace("https://"+this.companyItem.domain+".woodn1.com/transfer"+"?token="+response.data.data.token+"&domain="+this.companyItem.domain);
        },error=>{
          this.tip(error.data.message,"warning")
        });
      }
      // else if(!this.companyItem.current && !this.companyItem.sync_login){
      //   top.location.replace("https://"+this.companyItem.domain+".woodn1.com/login")
      // }
    },
    checkExpiry() {
      //$postLoc本地
      this.postFunc('/erp/company.valid.expiry', {}, res => {
        this.alertInfo = res.data.data;
      });
    },
    openOffer() {
      this.offer = true;
      this.postFunc("/erp/company.info", {}, res => {
        this.companyMess = res.data.data
      }, error => {
        this.tip(error.data.message, "warning")
      })
    },
    readAlert() {
      this.postFunc('/erp/charge.alert.read', {
        msg: JSON.stringify(this.alertInfo),
      }, () => {
        this.alertInfo.alert = false;
      });
    },
    showCompanyUrl() {
      window.open("https://www.woodn1.com/")
    },
    handleCommand(command) {
      if (command == "loginOut") {
        this.postFunc("/erp/user.logout",{},res=>{
          if (ws) {
            ws.close()
          }
          this.removeLocalStorge()
        })
      }
      // 个人中心
      if (command === "personal") {
        this.$root.$children[0].$children[0].addTab({
          name: '个人中心',
          label: '个人中心',
          content: 'settingPersonal'
        });
      }
      if (command === "document") {
        window.open("https://woodn1-static.oss-cn-shanghai.aliyuncs.com/%E8%B0%B1%E6%9C%A8%E4%BA%91ERP%E4%BD%BF%E7%94%A8%E8%AF%B4%E6%98%8E%E4%B9%A6.pdf")
      }
      if (command === "documentEasy") {
        window.open("https://woodn1-static.oss-cn-shanghai.aliyuncs.com/%E8%B0%B1%E6%9C%A8%E4%BA%91ERP%E6%96%B0%E7%94%A8%E6%88%B7%E7%AE%80%E5%8C%96%E4%BD%BF%E7%94%A8%E6%89%8B%E5%86%8C.pdf")
      }
      if (command === "document") {
          window.open("https://woodn1-static.oss-cn-shanghai.aliyuncs.com/%E8%B0%B1%E6%9C%A8%E4%BA%91ERP%E4%BD%BF%E7%94%A8%E8%AF%B4%E6%98%8E%E4%B9%A6.pdf")
      }
      if (command === "documentEasy") {
          window.open("https://woodn1-static.oss-cn-shanghai.aliyuncs.com/%E8%B0%B1%E6%9C%A8%E4%BA%91ERP%E6%96%B0%E7%94%A8%E6%88%B7%E7%AE%80%E5%8C%96%E4%BD%BF%E7%94%A8%E6%89%8B%E5%86%8C.pdf")
      }
      if(command === "Chrome"){
          window.open("https://www.google.cn/chrome")
      }
      if(command==='refresh'){
        this.$router.go(0)
      }
    },
    //PC端视频打开
    videoaDialoga(){
        this.videoaDialog = true;
    },
    //取消
    videoaCancel(){
        let myVideo = document.getElementById("video1");
        if(myVideo.paused){
              myVideo.pause();
        }
        else{
            myVideo.pause();
        }
        this.videoaDialog = false;
    },
    //移动端视频打开
    videobDialogb(){
        this.videobDialog = true;
    },
    //取消
    videobCancel(){
        let myVideo = document.getElementById("video2");
        if(myVideo.paused){
              myVideo.pause();
        }
        else{
            myVideo.pause();
        }
        this.videobDialog = false;
    },
    //谷歌下载视频打开
    videocDialogc(){
        this.videocDialog = true;
    },
    //取消
    videocCancel(){
        let myVideo = document.getElementById("video3");
        if(myVideo.paused){
              myVideo.pause();
        }
        else{
            myVideo.pause();
        }
        this.videocDialog = false;
    },
    //导入教学视频打开
    videodDialogd(){
        this.videodDialog = true;
    },
    videodCancel(){
      let myVideo = document.getElementById("video4");
        if(myVideo.paused){
              myVideo.pause();
        }
        else{
            myVideo.pause();
        }
        this.videodDialog = false;
    },
    //消息拖动
    movestart(e) {
      this.startX = e.x;
      this.startY = e.y;
      this.touchX = this.startX - e.offsetX;
      this.touchY = this.startY - e.offsetY;
      this.isMove = true;
    },
    moveFunc(e) {
      if (this.isMove) {
        let tX = e.x - this.startX;
        let tY = e.y - this.startY;
        this.startX = e.x;
        this.startY = e.y;
        let x = Number(this.$refs.message_path_box.style.left.replace("px", ""))
        let y = Number(this.$refs.message_path_box.style.top.replace("px", ""))
        this.$refs.message_path_box.style.left = (x + tX) + 'px';
        this.$refs.message_path_box.style.top = (y + tY) + 'px';
      }
    },
    touchend() {
      this.isMove = false;
    },
    //消息弹窗跳转
    jumpPage(name, index) {
      let url = "";
      switch (index) {
        case 0:
          url = "saleReview";
          break;
        case 1:
          url = "financeReceivable";
          break;
        case 2:
          url = "warehouseComponentsReceivableReceivableOutbound";
          break;
        case 3:
          url = "saleRefund";
          break;
        case 4:
          url = "warehouseDocReturn";
          break;
        case 5:
          url = " ";
          break;
        case 6:
          url = "getMoneyRemind";
          break;
        case 7:
          url = "purchaseMidwayBoard";
          sessionStorage.setItem("PURCHASEMIDWAYBOARD", 1)
          break;
      }
      let obj = new Object();
      obj.name = name;
      obj.label = name;
      obj.content = url;
      this.showTab(obj)
    },
    //socket通讯
    socket() {
      let _this = this;
      if ("WebSocket" in window) {
        let mess = localStorage.dw_erp_user_token;
        // ws = new WebSocket(process.env.VUE_APP_WSS + "?token=" + mess);
        ws = new WebSocket(process.env.VUE_APP_WSS );
        ws.onopen = function () {
          ws.send('{"type": "login","token":"'+mess+'"}')
          ws.send('{"type": "todo"}')
        };
        ws.onmessage = function (evt) {
          let msg = JSON.parse(evt.data);
          // window.console.log(msg)
          switch (msg.type) {
            case "ping":
              ws.send('{"type": "pong"}')
              break;
            case "msg":
              _this.tip(msg.message, "warning")
              break;
            case "todo":
              // _this.messFloat = msg.data;
              _this.menu_sign_data = Array.isArray(msg.data) ? _this.$cloneJson(msg.data) : [];
              var totalNumner = 0;
              let arrList = [];
              msg.data.forEach(item => {
                if(item.code=='redeem-order-manage' || item.code =='purchase-report-road-instore'|| item.code =='office-leave' ||item.code =='finance-fee-review'){
                    return
                }else{
                    if (_this.module.indexOf(',' + item.code + ',') != -1) {
                      totalNumner += item.value;
                    }
                    arrList.push(item);
                }
              })
               _this.messFloat = arrList;
              _this.totalMess = totalNumner;
              if (msg.message) {
                _this.tip(msg.message, "warning")
              }
              // if(totalNumner>0){
              // 	if(timeLimit==null){
              // 		_this.tip("您有新的待办事项要处理","warning")
              // 		// document.getElementById("audio").play();
              // 		timeLimit=setTimeout(function(){
              // 			timeLimit=null;
              // 		},5000)
              // 	}
              // }
              try {
                _this.$refs['homepage'].getTodo();
              } catch (e) {
                _this.pl(e)
              }
              break;
            case "logout":
              _this.tip(msg.message, "warning")
              ws.close();
              localStorage.removeItem("dw_erp_user_id");
              localStorage.removeItem("dw_erp_user_name");
              localStorage.removeItem("dw_erp_user_username");
              localStorage.removeItem("dw_erp_user_token");
              localStorage.removeItem("dw_erp_power_code");
              localStorage.removeItem("dw_erp_company_name");
              localStorage.removeItem("dw_erp_union_company");
              localStorage.removeItem("dw_erp_board");
              localStorage.removeItem("dw_erp_category");
              _this.$router.replace("/login");
              break;
          }
        };
        ws.onclose = function (err) {
          window.console.log(err)
        };
      } else {
        alert("您的浏览器不支持 WebSocket!");
      }
    },
    marginCenter(ref) {
      if (this.$refs.hasOwnProperty(ref)) {
        return -this.$refs[ref][0].offsetHeight / 2 + 'px';
      }
    },
    changeTab(activeName) {
      let tabs = this.tabs;
      tabs.forEach((tab) => {
        if (tab.name === activeName) {
          this.current_menu = tab.content;
        }
      });
    },
    closeTab(targetName) {
      this.removeTab(targetName);
    },
    addTab(item) {
      for (let tab of this.tabs) {
        if (tab.name == item.name) {
          this.current_tab = item.name;
          return;
        }
      }
      this.tabs.push({
        name: item.name,
        label: item.label,
        content: item.content
      });
      this.current_tab = item.name;
    },
    removeCurTab(){
      this.removeTab(this.current_tab);
    },
    removeTab(targetName) {
      let tabs = JSON.parse(JSON.stringify(this.tabs));
      let activeName = this.current_tab;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }
      this.current_tab = activeName;
      this.tabs = tabs.filter(tab => tab.name !== targetName);
      if (this.tabs.length == 0) {
        this.current_tab = "首页";
      }
    },
    removeNameTab(targetName,params){
      let tabs = JSON.parse(JSON.stringify(this.tabs));
      this.tabs.forEach((tab, index) => {
        if (tab.name == targetName) {
          this.tabs = tabs.filter(tab => tab.name !== targetName);
        }
      });
      setTimeout(() => {
        this.addTab(params);
      }, 10)
    },
    showTab(path) {
      if (path.module == "cloud-chain-product") {
        let routeData = this.$router.resolve({path: "/shopMall"});
        window.open(routeData.href, '_blank');
      } else if (path.module == "cloud-chain-cart") {
        let routeData = this.$router.resolve({path: "/shopCar"});
        window.open(routeData.href, '_blank');
      } else {
        for (let item of this.tabs) {
          if (item.name == path) {
            this.current_tab = path
            return;
          }
        }
        this.addTab(path);
      }
    },
    showCol(child) {
      let bool = false;
      child.children.forEach(item => {
        bool = bool || this.module.indexOf(item.module) >= 0
      })
      return bool;
    },
    newAdd(path, name) {
      let count = 0;
      for (let item of this.tabs) {
        if (item.content == path) {
          let temp = parseInt(item.name.replace(name, ''));
          if (temp > count) {
            count = temp;
          }
        }
      }
      ++count;
      this.showTab(
          {
            name: name + count,
            label: name,
            content: path
          }
      )
    },
    getNumFromBells(conf = []) {
      if (typeof conf === "string" && conf) {
        conf = [conf];//单个sign时，转为数组统一运算
      }
      if (Array.isArray(conf) && conf.length > 0) {
        let relateArr = this.menu_sign_data.filter(a => conf.includes(a.code)).map(a=>a.value);
        return this.$bc_add(...relateArr);
      }else{
        return 0;
      }
    },
    getMenuSignNumRecursive(recArr=[]) {
      if (Array.isArray(recArr)) {
        recArr.forEach(it => {
          if (it.hasOwnProperty('bell_signs')) {
            it.num = this.getNumFromBells(it.bell_signs);
          }
          if (it.hasOwnProperty('children')) {
            this.getMenuSignNumRecursive(it.children);
          }
        });
      }
    },
  },
  // 自定义指令 实现可拖动
  directives: {
    drag(el, bindings) {
      el.onmousedown = function (e) {
        var disx = e.pageX - el.offsetLeft
        var disy = e.pageY - el.offsetTop
        document.onmousemove = function (e) {
          el.style.left = e.pageX - disx + 'px'
          el.style.top = e.pageY - disy + 'px'
        }
        document.onmouseup = function () {
          document.onmousemove = document.onmouseup = null
        }
      }
    }
  },
  watch: {
    current_tab(value) {
      setTimeout(() => {
        if (this.$refs.hasOwnProperty(value) && (!this.$refs[value].hasOwnProperty('_uid')) && this.$refs[value][0].hasOwnProperty('getList')) {
          this.$refs[value][0].getList();
        }
        // if(this.$refs.hasOwnProperty(value) && ( !this.$refs[value].hasOwnProperty('_uid') ) && this.$refs[value][0].hasOwnProperty('getDetail')){
        // 	this.$refs[value][0].getDetail();
        // }
        if (this.$refs.hasOwnProperty(value) && this.$refs[value].hasOwnProperty('_uid') && this.$refs[value].hasOwnProperty('init')) {
          this.$refs[value].init();
        }
        // if(value.indexOf("提货单详情")!=-1&&this.$refs.hasOwnProperty(value)){
        // 	this.$refs[value][0].getDetail();
        // 	this.$refs[value][0].getPrintDetail();
        // }
      }, 20)
    },
    menu_sign_data: {
      deep:true,
      immediate:true,
      handler:function (val) {
        if (val.length > 0) {
          //非系统消息变动，更新菜单栏数字
          this.getMenuSignNumRecursive(this.menu_list);
        }
      }
    }
  }
};
</script>
<style scoped  lang="scss">
/*alert*/
.elHeader{position: relative; z-index: 3000;}
.modalBox{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0,0,0,0.3);
  z-index: 999;
}
.alertBox {
  position: fixed;
  z-index: 99999;
  top: 50vh;
  left: 50vw;
  transform: translate(-50%,-50%);
  background: #fff;
  border: 1px solid #ccc;
  width: 550px;
  height: 430px;
  font-size: 14px;
  .topBox{
    padding: 8px 20px;
    text-align: center;
    color: red;
    font-weight: 700;
    font-size: 16px;
    border-bottom: 2px solid #ccc;
  }
  .midBox{
    padding: 10px 30px;
    border-bottom: 1px solid #222;
    .midItem{
      margin-bottom: 10px;
      .lightColor{
        color: #ff9914;
      }
    }
    .midSign{
      text-align: right;
      padding-right: 80px;
    }

  }
  .bottomBox{
    padding: 10px 150px 10px 30px;
    position: relative;
    .left{
      .bottomItem{
        margin-bottom: 2px;
        &.accountTitle{
          margin-bottom: 10px;
        }
      }
    }
    .right{
      position: absolute;
      top: 10px;
      right: 30px;
      .payTypeItem{
        margin-bottom: 10px;
      }
      .payImg{
        width: 100px;
        height: 100px;
      }
    }
  }
  .readBtnDiv{
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    .readBtn{
      border-color: #111;
      padding: 10px 30px;
    }
  }
}
.mobileCodeBox{float: right;position: relative;padding-right:20px;}
.mobileCodeName{font-size: 14px;cursor: pointer;}
.mobileCodeBoxC{width:auto;height:auto;display: none;position: fixed;top:50px;right:0px;margin: auto;z-index:4500 !important;background-color: #fff;box-shadow: 0 0 5px #ccc;}
.mobileCodeImgBox{width:120px;margin-top:20px;float: left;margin-left:10px;margin-right:10px;}
.mobileCodeImgName{font-size: 12px;color:#777;text-align: center;padding:5px 0;line-height: 25px;}
.mobileCode{width:120px;height:120px;display: block;margin:auto;}
.mobileCodeBox:hover .mobileCodeBoxC{display: block;}
.mobileCodeImg{width:18px;height:18px;margin-left:5px;position: relative;top:2px;}
.triangle-up{width: 0;height: 0;border-left: 8px solid transparent;border-right: 8px solid transparent;border-bottom: 15px solid #fff;position: absolute;top:-15px;left:150px;}

.asideLogo{width:60px;display:block;margin: auto;margin-bottom:10px;cursor: pointer;}
.companyName{float: left;font-size: 16px;font-weight: 600;}
.meun_arrow{position: absolute;top: 50%;transform: translateY(-50%);left: -25px;color: #fff;font-size: 25px;}
.el-header,.el-footer {background-color: #fff;color: #333;text-align: center;line-height: 48px;height: 48px!important; text-align: right;}
.el-aside {color: #333;text-align: center;}
.el-main {background-color: #e9eef3;color: #333 !important;text-align: center;}

.header { color: #333; line-height: 40px; background-color: #333333; color: #fff; }
.aside{
  background: #001529; width:83px!important; min-height: 100%; position: relative; z-index: 20000;
  .full_height_scrollbar{ height: calc(100%); background-color: #fff; padding-top: 20px; background-color: #292C2E; box-sizing: border-box; }
  .menu{background-size: 100%; position: relative; color: #fff; z-index: 10; text-align: center; cursor: pointer; margin-bottom: 20px;}
  .menu .item{ display: flex; align-items: center; padding: 10px 0; text-align: left;}
  .menu .item > i{ font-size: 26px; position: relative; }
  // .menu .item > div{ width: 100%; font-size: 15px; display: flex; align-items: center; flex-direction: column; justify-content: center; }
  .menu .item > div{ width: 100%; font-size: 15px;  }
  .menu .item > div > i{ font-size: 38px; }
  .menu .children_menu{ display: flex; visibility: hidden; z-index: -1;position: absolute; top: 50%; left: calc( 100% + 0px); white-space: nowrap; padding: 15px 0px; line-height: 1; text-align: left; background: #292C2E; color: #fff; border:3px solid #B21111; border-radius:10px; }
  .menu.active{ background:url("/icon/nav_bg.png") no-repeat transparent center right; background-size: 75px 47px; color: #FF9100; }

  // hover
  .menu.show { background:url("/icon/nav_bg.png") no-repeat transparent center right; background-size: 75px 47px; color: #FF9100; }
  .menu.show .children_menu{ visibility: visible; z-index: auto; }
  .menu .title{ font-size: 18px; font-weight: 700;  margin-bottom: 15px; }
  .menu .link{ cursor: pointer; display: flex; align-items: center; justify-content: space-between; }
  .menu .link + .link{ margin-top: 15px; }
  .menu .link .node_btn{ visibility: hidden; position: relative; z-index: -1; margin-left: 10px; }
  .menu .link:hover .node_btn{ visibility: visible; z-index: 0; }
  .menu .sub_link{ font-size: 14px;  color: #fff;margin:7px 0;}
  .menu .link:hover .sub_link{ color: #F7A502; }
  .children_menu .menu_col{
    padding: 0px 20px; min-width: 100px;
    .col_name{ margin-bottom: 10px;}
  }
  .children_menu .menu_col + .menu_col{ border-left: 1px solid #B21111; }
  .children_menu .menu_col_other + .menu_col_other{ border-left: 1px solid #B21111; }
}
.main { padding: 0;background-color:#efefef; width:100%; position: relative; /*height: 100%;*/ }
.tab_content { height: 100%;overflow: auto; }

.text-right{color:#333;}
.col_icon{width:50px;}
.col_left{width:200px;}
.col_right{text-align: right;}
h4{ /*color:#595959;*/ color:#fff; }
.el-dropdown-link{ cursor: pointer; color: #fff; }
.instructions{margin-bottom:10px;cursor: pointer; transition: all .2s linear;text-decoration:underline}
.instructions:hover{color: #F7A502;text-decoration:underline}

.message_path_box{width:18px; position: fixed; height:38px;  user-select: none; z-index: 21474836451;top:200px;left:200px;}
.message_path{ width:18px;  height:38px;
  .sub_path{ width:700px; height:38px; background: #ECECEC; border-radius:19px;  display: flex; align-items: center; padding-left: 52px; white-space: nowrap; overflow: hidden; transition-duration: 0.5s;}
  &.hide_sub .sub_path{ width:0; padding-left: 38px}
  i{ display: inline-block; width:16px; height:16px; background: #F11B1B; border-radius:50%; color: #fff; font-style: normal; font-size:12px; }
  .sub_mess{margin:0 10px;
    cursor: pointer;
    i{ margin-left: 5px; }
    & + .sub_mess{ margin-left: 28px; }
  }
  .message_round{
    width:40px; height:40px; background: #155BD4; border-radius:50%; position: absolute; left: -1px; top: -1px; color: #fff; padding-top: 12px; text-align: center; font-size:12px; cursor: pointer;
    & > i{ position: absolute; top:-4px; right: 0;  }
  }
}
.message_path_boxs{width:18px; position: fixed; height:38px;  user-select: none; z-index: 21474836451;left:200px;bottom: 160px;}
.message_paths{ width:18px;  height:38px;
  &.hide_sub .sub_path{ width:0; padding-left: 38px}
  .sub_mess{margin:0 10px;
    cursor: pointer;
    i{ margin-left: 5px; }
    & + .sub_mess{ margin-left: 28px; }
  }
  .message_round{
    width:50px; height:50px; background: #B21111; border-radius:50%; position: absolute; left: -1px; top: -1px; color: #fff; padding-top: 9px; text-align: center; font-size:12px; cursor: pointer;
    & > i{ position: absolute; top:-4px; right: 0;  }
  }
}
.itemBox{text-align: center;
  i{display: block;float: left;margin:0 5px 0 15px;}
  div{display: block;float: left;}
}
.company_title{width: 30px;}
.offerTitle{display: flex;justify-content: center;align-items: center;}

/*菜单项新增配置*/
.aside{
  width: 92px !important;
  .children_menu {
    .menu_col{
      padding: 0;
    }
  }
  .menu{
    .link{
      padding: 6px 15px;
    }
    &.active,&:hover{
      background-size: 92px 47px;
    }
    /deep/ .el-badge__content{
      font-size: 12px;
      height: 15px;
      line-height: 11px;
      padding: 2px 3px;
      border: none;
      border-radius: 10px;
    }
    /deep/ .lessNum .el-badge__content{
      padding-left: 5px;
      padding-right: 6px;
    }
    /deep/ .overNum .el-badge__content{
      padding-left: 4px;
    }
    .alertNumber{
      width: 27px !important;
      position: absolute;
      right: 3px;
      top: 0;
    }
    .linkAlertNum{
      margin-left: 10px;
    }
    .item{
      .itemBox i{
        margin-left: 8px;
      }
    }
  }
}
.mall{font-size: 14px;&:hover{color:#EC1313;}}
.topAvatarDiv{
        height: 50px;
        box-sizing: border-box;
        padding-right: 10px;
        .topAvatar{
            width: 50px;
            height: 50px;
            padding: 10px;
            border-radius: 50%;
        }
        &:hover{
            background-color: #fff;
        }
}
.separateLine{
        display: inline-block;
        height: 19px;
        border-right: 1px solid #333;
}
.perBgTopDiv{
        z-index:4500 !important;
        background: #292C2E;
        color: #fff;
        width: 250px;
        height: 160px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .perTopItem{
            .avatar{
                width: 80px;
                height: 80px;
                border-radius: 50%;
                background-color: #fff;
            }
            .phone {
              width: 15px;
              height: 15px;
              border-radius: 50%;
            }
        }
}
  .fphone {margin-right: 5px;}
</style>
